<template>
    <div>
        <div v-show="showDropdown">
            <select
                :name="name"
                class="form-control"
                :class="{ 'is-invalid': isInvalid }"
                ref="picker"
                style="width: 100%;"
                :id="id"
                :required="required"
            >
                <option v-if="this.defaultValue != ''" :value="this.defaultValue.key" selected>{{this.defaultValue.value}}</option>
            </select>
        </div>
        <template v-if="canAddNew && addNewModal != ''">
            <component
                :is="addNewModal"
                :save-modal-route="saveModalRoute"
                :modal-data="modalData"
                :toggle="openComponent"
                :selectName="name"
                @input="addSelectedOption"
                @hideDropdown="showDropdown = false"
                @showDropdown="showDropdown = true"
            ></component>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        placeholder: {
            type: String,
            default: 'Please select',
        },
        name: {
            type: String,
            required: true,
        },
        id: {
            type: String,
        },
        route: {
            type: String,
            required: true,
        },
        defaultValue: {
            type: [String, Number],
            default: '',
        },
        defaultValues: {
            type: Array,
            default() {
                return [];
            },
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        queryStringParams: {
            type: Object,
            default() {
                return {};
            },
        },
        canAddNew: {
            type: Boolean,
            default: false,
        },
        addNewModal: {
            type: String,
            default: ''
        },
        saveModalRoute: {
            type: String,
            default: ''
        },
        modalData: {
            type: Object,
            default() {
                return {}
            },
        },
    },

    data ()  {
        return {
            storedRoute: this.route,
            picker: null,
            queryString: null,
            loaded: false,
            buttonAdded: false,
            openComponent: false,
            showDropdown: true,
        };
    },

    async mounted() {
        await this.populateFromAjax();
        Eventbus.on('newSelect' + this.name, (payload) => {
            this.picker.append(
                    window
                        .jQuery(`<option selected>${payload[0]}</option>`)
                        .val(payload[1])
                );
        });
    },

    methods: {
        async addSelectedOption(defaultValue) {
            this.queryString.set('id', defaultValue);
            let chosenOne = await axios
                .get(`${this.storedRoute}?${this.queryString.toString()}`)
                .then((response) => {
                    if (response.data.data.length != 1) {
                        alert('Unable to set default value, please contact support');
                        throw new Error('Invalid data received.');
                    }
                    return response.data.data[0];
                });

            // if default value allowed to fail
            // this will become undefined
            if (chosenOne !== undefined) {
                this.picker.append(
                    window
                        .jQuery(`<option selected>${chosenOne.text}</option>`)
                        .val(chosenOne.id)
                );
            }
        },

        async populateFromAjax() {
            this.queryString = new URLSearchParams();

            if (Object.entries(this.queryStringParams).length > 0) {
                for (const key of Object.keys(this.queryStringParams)) {
                    this.queryString.append(key, this.queryStringParams[key]);
                }
            }

            let select2Options = {
                placeholder: this.placeholder,
                allowClear: (! this.multiple),
                ajax: {
                    cache: true,
                    data: function (params) {
                        return {
                            search: params.term,
                            page: params.page,
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: data.data,
                        };
                    },
                    url: `${this.storedRoute}?${this.queryString.toString()}`,
                },
                multiple: this.multiple,
            }

            const modalParent = window.jQuery(this.$refs.picker).parents('.modal');

            if (modalParent.length) {
                select2Options.dropdownParent = modalParent[0];
            }

            this.picker = window
                .jQuery(this.$refs.picker)
                .select2(
                    select2Options,
                );

            this.picker.on('change', e => {
                this.$emit('update:model-value', this.picker.select2('val'));
            });

            // this needs to be recreated each open for some reason
            this.picker.on('select2:open',  () => {
                if (this.canAddNew && this.buttonAdded === false) {
                    let a = this.picker.data('select2');

                    if (! window.jQuery('.select2-link', a).length) {
                        a.$results.parents('.select2-results')
                            .append('<div class="my-2 d-flex flex-row justify-content-center"> <a class="btn btn-success">Add New</a></div>')
                            .on('click', () => {
                                Eventbus.emit('add-new' + this.name);
                                this.picker.select2('close');
                            });
                        this.buttonAdded = true;
                    }
                }
            });
        },
    },
};
</script>
